import { Alert, Box, Stack, styled } from '@mui/material';

export const NotificationAlert = styled(Alert)`
  background-color: var(--dk-bg, white);
  max-width: 25rem;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.12);
`;

const StyledTitle = styled(Box)`
  font-size: 1rem;
  color: var(--text-secondary-color);
`;

const StyledContent = styled(Box)`
  font-size: 1rem;
  font-weight: bold;
  color: var(--text-primary-color);
  white-space: pre-line;
  word-wrap: break-word;
`;

export const NotificationContentWrapper = styled(Stack)`
  flex-direction: column;
  gap: 0.5rem;
`;
export { StyledTitle, StyledContent };
